import React from 'react'
import { connect } from 'react-redux'
import { captureException } from '@sentry/browser'

import '../sass/top-level-error-boundary.scss'
import { back } from '../actions/navigation'

interface StateProps {
}

interface DispatchProps {
  back: () => void
}

interface OwnProps {}

export type TopLevelErrorBoundaryProps = StateProps & DispatchProps & OwnProps

function mapStateToProps (state): StateProps {
  return {
  }
}

function mapDispatchToProps (dispatch): DispatchProps {
  return {
    back: () => dispatch(back())
  }
}

type State = {
  hasError: boolean
}

class TopLevelErrorBoundaryComponent extends React.Component<TopLevelErrorBoundaryProps, State> {
  constructor(props) {
    super(props)
    this.state = {
      hasError: false
    }
  }

  componentDidCatch (error, info) {
    this.setState({ hasError: true })
    captureException(error)
  }

  handleBackClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    this.props.back()
    this.setState({
      hasError: false
    })
  }

  render () {
    if (this.state.hasError) {
      return (
        <div className='error-boundary-container'>
          <div className='error-boundary-middle'>
            <div className='error-boundary-header'>Sorry, something went wrong!</div>
            <p>An error occurred somewhere in the deep ocean of code, hopefully nothing major and the
              button will take you back to your work. If not we're sorry to say you need
              to refresh the page.
            </p>
            <div>
              <button className='button primary' onClick={this.handleBackClick}>Back</button>
            </div>
          </div>
        </div>
      )
    }
    return this.props.children
  }
}

const TopLevelErrorBoundary = connect(mapStateToProps, mapDispatchToProps)(TopLevelErrorBoundaryComponent)

export {
  TopLevelErrorBoundary
}
